/* Kherajani: after an add-to-cart the theme's drawer removes is-empty from .drawer__inner only, so on a previously empty cart the
   drawer root kept is-empty and showed a blank panel. Clear it on the root as well, before the theme renders the new contents. */
(function () {
  function patch() {
    var C = customElements.get('cart-drawer');
    if (!C || C.prototype.__khcFix) return;
    var orig = C.prototype.renderContents;
    C.prototype.renderContents = function (state) {
      this.classList.remove('is-empty');
      return orig.call(this, state);
    };
    C.prototype.__khcFix = true;
  }
  if (window.customElements && customElements.whenDefined) customElements.whenDefined('cart-drawer').then(patch);

  /* Stage 16: pressing minus at quantity 1 inside the drawer made the theme look for #Quantity-N (cart page id) and throw.
     Look up the drawer input id as well so the field simply resets to 1 (use the bin icon to remove an item). */
  function patchItems() {
    var I = customElements.get('cart-drawer-items');
    if (!I || I.prototype.__khcFix2) return;
    I.prototype.resetQuantityInput = function (id) {
      var input = this.querySelector('#Quantity-' + id) || this.querySelector('#Drawer-quantity-' + id);
      if (input) input.value = input.getAttribute('value');
      this.isEnterPressed = false;
    };
    I.prototype.__khcFix2 = true;
  }
  if (window.customElements && customElements.whenDefined) customElements.whenDefined('cart-drawer-items').then(patchItems);

  /* Cart page: show prices the same way as the drawer, product cards and product pages (no trailing .00, no extra AED word after the symbol). */
  function tidyCartPage() {
    var sel = '.price, .totals__total-value, .cart-item .product-option, .cart-item__old-price, .cart-item__final-price, .discounts__discount';
    var roots = [document.getElementById('main-cart-items'), document.getElementById('main-cart-footer')].filter(Boolean);
    if (!roots.length) return;
    function tidy() {
      roots.forEach(function (r) {
        r.querySelectorAll(sel).forEach(function (el) {
          var w = document.createTreeWalker(el, 4, null, false), n, list = [];
          while ((n = w.nextNode())) { if (/(\d)\.00(?!\d)|\bAED\b/.test(n.nodeValue)) list.push(n); }
          list.forEach(function (t) {
            var v = t.nodeValue.replace(/(\d)\.00(?!\d)/g, '$1').replace(/\s*\bAED\b/g, '');
            if (v !== t.nodeValue) t.nodeValue = v;
          });
        });
      });
    }
    tidy();
    var mo = new MutationObserver(function () { tidy(); });
    var host = document.querySelector('main') || document.body;
    mo.observe(host, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tidyCartPage); else tidyCartPage();
})();
